/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The console instance provisioning steps property.
 * @export
 */
export type EntityConsoleStep = io.TypeOf<typeof ConsoleStep>;

/**
 * The console instance provisioning step property.
 * @export
 */
export const ConsoleStep = io.type(
  {
    currentStep: io.number,
    steps: io.array(io.type({ message: io.string })),
    totalSteps: io.number,
  },
  `ConsoleStep`,
);
